'use client';

import { useInvestorQuery } from '@/hooks/use-investor-query';
import { fetchInvestorAttribution } from '../api/get-investor-attribution';
import { portfolioKeys } from '@/lib/investor-keys';
import { SLOW_CADENCE_MS } from '../api/keys';
import type { InvestorMetricWindow } from '@/lib/investor-analytics';
import type { InvestorAttributionResponse } from '../types/api';

export function useInvestorAttribution(
  params: { window?: InvestorMetricWindow } = {}
) {
  return useInvestorQuery<InvestorAttributionResponse>({
    key: ({ address, chainId }) =>
      portfolioKeys.attribution(address, chainId, params.window),
    fetch: ({ address, chainId }, signal) =>
      fetchInvestorAttribution(address, chainId, params, signal),
    // A window aggregate moves with the daily valuation, not by the minute.
    // Polling it every 60s only added to a page that already fans out, and
    // the rate limiter is a hard budget shared by every screen.
    cadenceMs: SLOW_CADENCE_MS
  });
}
